<mat-drawer-container class="main-content">
    <mat-drawer mode="side" opened *ngIf="checkLoginStatus">
        <app-side-nav></app-side-nav>
    </mat-drawer>
    <mat-drawer-content class="content">
        <router-outlet></router-outlet>
    </mat-drawer-content>
</mat-drawer-container>
